import { useEffect, useState } from "react";
import { OTPMAXTIME } from "../../utils/constants";

export const CountdownTimer = ({
  onClick = () => {},
  text = "Resend",
  onTimerComplete = () => {},
}: {
  onClick: () => void;
  text: string;
  onTimerComplete?: () => void;
}) => {
  const [countValue, setCountValue] = useState(OTPMAXTIME);

  useEffect(() => {
    const myTimeout =
      countValue > 0 &&
      setTimeout(() => {
        setCountValue(countValue - 1);
      }, 1000);

    return () => {
      if (myTimeout) {
        clearTimeout(myTimeout);
      }
    };
  });

  useEffect(() => {
    if (countValue === 0) {
      onTimerComplete();
    }
    // eslint-disable-next-line
  }, [countValue]);

  return (
    <div className="text-grey-600 text-sm">
      {text} {countValue > 0 && `in`}{" "}
      <button
        onClick={() => {
          onClick();
          setCountValue(OTPMAXTIME);
        }}
        disabled={countValue > 0}
        className="underline"
      >
        {countValue > 0
          ? `${countValue} ${countValue > 1 ? "secs" : "sec"}`
          : "now"}
      </button>
    </div>
  );
};
